import { render } from "./MypageCommunityComment.vue?vue&type=template&id=3e0db7fc&scoped=true"
import script from "./MypageCommunityComment.vue?vue&type=script&lang=js"
export * from "./MypageCommunityComment.vue?vue&type=script&lang=js"

import "./MypageCommunityComment.vue?vue&type=style&index=0&id=3e0db7fc&lang=scss&scoped=true"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0db7fc"]])

export default __exports__